import { createSlice } from "@reduxjs/toolkit";

export const analyticalNotesListSlice = createSlice({
  name: "analyticalNotesList",
  initialState: {
    byId: {},
    allIds: [],
    totalRecords: 0,
    selectedAnalyticalNote: null,
    filteredRecords: 0,
    isSingleAnalyticalNoteLoading: false,
    isLoading: false,
    isAnswerByTechTeam: false,
  },
  reducers: {
    setAllAnalyticalNotesLoadingState: (state, action) => {
      state.isLoading = true;
    },
    setSingleAnalyticalNotesLoadingState: (state, action) => {
      state.isSingleAnalyticalNoteLoading = true;
    },
    loadAllAnalyticalNotes: (state, action) => {
      const listObj = {};
      action.payload.analyticalNotes.forEach((value) => {
        listObj[value.id] = value;
      });
      state.byId = listObj;
      state.allIds = action.payload.analyticalNotes.map((value) => value.id);
      state.totalRecords = action.payload.totalRecords;
      state.filteredRecords = action.payload.filteredRecords;
      state.isLoading = false;
    },
    loadSingleAnalyticalNote: (state, action) => {
      state.selectedAnalyticalNote =
        action.payload && action.payload.length === 1
          ? action.payload[0]
          : null;
      state.isSingleAnalyticalNoteLoading = false;
    },
  },
});

export const {
  setAllAnalyticalNotesLoadingState,
  setSingleAnalyticalNotesLoadingState,
  loadAllAnalyticalNotes,
  loadSingleAnalyticalNote,
} = analyticalNotesListSlice.actions;

export default analyticalNotesListSlice.reducer;
